import { render, staticRenderFns } from "./goodsListByCourseActivity.vue?vue&type=template&id=1027fccc&scoped=true"
import script from "./goodsListByCourseActivity.vue?vue&type=script&lang=js"
export * from "./goodsListByCourseActivity.vue?vue&type=script&lang=js"
import style0 from "./goodsListByCourseActivity.vue?vue&type=style&index=0&id=1027fccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027fccc",
  null
  
)

export default component.exports